// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"Modal_modal_wrapper__jgSz0","modal_wrapper__send":"Modal_modal_wrapper__send__1lC9V","wrapper":"Modal_wrapper__6+lZI","tableTitleCell":"Modal_tableTitleCell__tU9Hv"};